import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { Typeahead, ClearButton } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import customerSummaryClient, {allCustomerSummaryClient} from '../../utility/apiClients/customer/customerSummaryClient';
import AccountDetailsClient from '../../utility/apiClients/account/accountDetailsClient';
import $ from 'jquery';
import invoiceCSS from "../../styles/myInvoices.module.scss";
import OverLayLoader from '../loader/overlayLoader';
import Loader from '../loader';
import { getDataFromLocalStorage } from '../../utility/utils/utility';
import {invoiceAmountDue } from '../../utility/features/helpers/accountHelper';
import { amountFormatter }  from '../../utility/utils/formatter';
import Globals from '../../utility/constants/appConstants';
import PaymetricModal from './paymetricModal';
import { decryptData } from '../../utility/utils/hashing';
import { setCookie } from '../../utility/utils/cookie';
import { GetAccessToken } from '../../utility/apiClients/account/paymetricClient';
import paymentStatusClient from '../../utility/apiClients/payments/paymentStatusClient';
import { Pagination } from "../Pagination";
import "../../styles/pagination.css";
import ViewPaymentMethodsClient from '../../utility/apiClients/customer/ViewPaymentMethodsClient';
import { setSelectedServiceAddress } from "../../reduxStore/myAccount/accountSummarySlice";
import { formatDateMMDDYYYY, formatDateYYYYMMDD } from "../../utility/utils/dateUtil";
import { IsLoggedIn as loginStatus } from "../../utility/features/helpers/authHelper";
import { setCustomerInfo } from "../../reduxStore/login/loginSlice";
import missionStatusClient from '../../utility/apiClients/user/missionStatusClient';
import MissionStatusChecker from '../missionStatusChecker';
import { setSelectedCustomer } from "../../reduxStore/login/loginSlice";
import { encryptData } from '../../utility/utils/hashing';

const Invoices = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [totalAmount, setTotalAmount] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [paymentType, setPaymentType] = useState('card');
    const userData = useSelector((state) => state.login.userData);
    const customerInfo = useSelector((state) => state.login.invoiceCustomerInfo);
    const {custEmail} = userData;
    const [customerSummaryData, setCustomerSummaryData] = useState(customerInfo?.[0] || null);
    const custNumbers = JSON.parse(localStorage.getItem("customerNumbers")) || [];
    const [selectedCustomerNumber, setSelectedCustomerNumber] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState({});
    const [paidInvoices, setPaidInvoices] = useState(() => {
        const stored = localStorage.getItem('paidInvoices') ? JSON.parse(localStorage.getItem('paidInvoices')) : [];
        // drop stale/malformed entries that aren't {invoiceNumber, saNumber} objects
        return stored.filter(inv => inv && typeof inv === 'object' && 'invoiceNumber' in inv);
    });
    const [selectedZIP, setSelectedZIP] = useState(null);
    const [allSA, setAllSA] = useState([]);
        const [invoiceStatuses, setInvoiceStatuses] = useState({
        processing: [],
        failed: [],
        success: [],
        not_found: [],
        onqueue: [],
        pending:[]
    });
    const isLoggedIn = loginStatus();
    const [allCusAddresses, setAllCusAddresses] = useState(null);
    const [addressInfo, setAddressInfo] = useState({selectedAddr: '', custNo: ''});
    const [selectedServiceAddr, setSelectedServiceAddr] = useState([]);
    const [addressByCust, setAddressByCust] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOverLayLoading, setIsOverLayLoading] = useState(false);
    const [allInvoices, setAllInvoices] = useState([]);
    const [invoiceError, setInvoiceError] = useState("");
    const [error, setError] = useState("");
    const [csError, setCsError] = useState("");
    const [isIB, setIsIB] = useState(false);
    const [iframeURLToken, setIframeURLToken] = useState({IFrameUrl: '', AccessToken: ''});
    const [iframeLoading, setIframeLoading] = useState(false);
    const [missionDown, setMissionDown] = useState(false);

    const [invoicePayAPIPayload, setInvoicePayAPIPayload] = useState({
        activeServiceAgreements: [],
        finalSA: [],
        customerNum: "",
        email: "",
        paymentMethod: {}
    })

    const [currentController, setCurrentController] = useState(null);

    const [page, setPage] = useState(1);
    const pageSize = 10;

    const totalItems = allInvoices ? allInvoices.length : 0;
    const showPagination = totalItems > pageSize;

    const pageData = useMemo(() => {
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        return allInvoices
        ? allInvoices.slice(start, end)
        : [];
    }, [allInvoices, page, pageSize]);

    useEffect(() => {
        const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
        if (page > totalPages) setPage(totalPages);
    }, [page]);
        
    const missionStatusCheck = async () => {
        try {
            const missionStatus = await missionStatusClient();
            return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
        }
        catch (err) {
            console.error("Error checking mission status api:", err);
            return false;
        }
    }

    // make an array based on user checkbox selection
    const handleInvoiceSelection = (e) => {
        const invoiceId = e.target.id.replace('due-pay-', '');

        const encryptedCustNo = selectedCustomerNumber ? encryptData(`${selectedCustomerNumber}__customervalue${Date.now()}`, "customerNumber") : '';
        const formatedCustomerNumber = encryptedCustNo.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        
        let totalAmt = 0;
        let slctdInvoices = {}
        
        slctdInvoices = {...selectedInvoices, [invoiceId]: allInvoices.filter(invoice => {
            if(e.target.checked && invoiceId.includes(invoice.invoiceNo)) {
                let sa_arr = invoice.salesAgrNum.split(", ");
                sa_arr = [...new Set(sa_arr)];

                invoice.salesAgrNum = sa_arr.join(", ");
                return true;
            }
            else
                return false;
        })};

        for (const key of Object.keys(slctdInvoices)) {
            let invoice = slctdInvoices[key];
            if(invoice.length > 0)
                totalAmt += invoice[0]?.payTotalPymt;
        }

        setSelectedInvoices(slctdInvoices);
        setTotalAmount(parseFloat(totalAmt).toFixed(2));

        let completeSA = [];
        let openSalesAgr = [];

        let activeServiceAgreements = [];   
        Object.values(slctdInvoices).forEach(invoiceArr => {
            if(invoiceArr.length > 0){

                invoiceArr?.length > 0 && invoiceArr?.forEach(inv => {
                      if (inv.payTotalPymt > 0 ) {
                        activeServiceAgreements.push({
                            payTotalPymt: inv.payTotalPymt,
                            salesAgrNum: inv?.salesAgrNum,
                            invoiceNo: inv?.invoiceNo,
                            payBunit: inv?.payBunit
                        });

                        allSA.length > 0 && allSA.forEach(SA => {
                            let flag = false;
                            completeSA.length > 0 && completeSA.forEach(saleAggr => {
                                // if(saleAggr.salesAgrNum === SA.salesAgrNum){
                                if(saleAggr.salesAgrNum.includes(SA.salesAgrNum)){
                                    flag = true;
                                    return;
                                }
                            })

                            // if(inv?.salesAgrNum === SA.salesAgrNum && flag === false){
                            if(inv?.salesAgrNum.includes(SA.salesAgrNum) && flag === false){
                                completeSA.push(SA);
                            }
                        });
                    }
                })
            }
        });

        completeSA.forEach((sa) => {
            let salesnumber = sa.salesAgrNum;
            let serviceDesc = sa.svcLineDesc;

            sa.Invoices.forEach((invoice) => {
              if (invoice.invoiceOpen === "Y" && Object.keys(slctdInvoices).includes(invoice.invoiceNum) && slctdInvoices?.[invoice.invoiceNum].length > 0) {
                let formattedDate = formatDateYYYYMMDD(invoice.workOrderSvcDate);
                let urlDate = formattedDate.replace(
                    /(\d\d\d\d)(\d\d)(\d\d)/,
                    "$1/$2/$3"
                );
                // let invoiceBalance = invoice.invoiceBalance.toString().split(".");
                let invoiceBalance = slctdInvoices?.[invoice.invoiceNum]?.[0]?.totalbySA[salesnumber].toString().split(".");

                let invAmtIntPart = Globals.currencySymbol + invoiceBalance[0];
                let invAmtFractPart = invoiceBalance[1]
                    ? invoiceBalance[1].length < 2
                    ? invoiceBalance[1] + "0"
                    : invoiceBalance[1].substring(0, 2)
                    : "00";
                let dateMMDDYYYY = formatDateMMDDYYYY(invoice.workOrderSvcDate);
                const encryptedWONo = selectedCustomerNumber && invoice.workOrderRef ? encryptData(invoice.workOrderRef + `__documentvalue${Date.now()}`, "serviceWorkOrder") : "";
        
                openSalesAgr.push({
                    invAmtIntPart,
                    invAmtFractPart,
                    salesAgrNum: salesnumber,
                    svcDescription: serviceDesc,
                    invoice: invoice,
                    ticketLink: selectedCustomerNumber && invoice.workOrderRef ? `${process.env.REACT_APP_DOMAIN_URL}/document/commercial/${formatedCustomerNumber}/workordernumber/${encryptedWONo}` : '',
                    invoiceNumber: invoice.invoiceNum,
                    invoiceOpen: invoice.invoiceOpen,
                    date: dateMMDDYYYY,
                    desc: invoice.svcDescription,
                    totalAmt: parseFloat(invoiceBalance[0]+"."+invAmtFractPart)
                }); 
              }
            });
        });

        const finalSA = makeSalesAgreementObj(openSalesAgr);

        setInvoicePayAPIPayload({
            ...invoicePayAPIPayload,
            activeServiceAgreements: activeServiceAgreements,
            finalSA: finalSA,
            customerNum: selectedCustomerNumber[0] || "",
            email: customerSummaryData?.EmailAddress || custEmail || "",
        });
    }

    const getCustomerSummary = async (custNum, type) => {
        setIsOverLayLoading(false);
        if(custNum === "") return;

        const isMissionAvailable = await missionStatusCheck();
        if (!isMissionAvailable) {
            setMissionDown(true);
            setIsOverLayLoading(false);
            return;
        }

        if(type === "byCustNum"){
            setIsOverLayLoading(true);
            setAllInvoices([]);
            setCsError("");
            setSelectedInvoices({});
            setTotalAmount(0);
            setInvoiceError("");
        }
        try{
            let customerSummary;
            if(customerInfo && customerInfo.length > 0 && isLoggedIn){
                let custData = customerInfo.find(c => c.CustomerNumber === custNum);
                customerSummary = { 
                    data: custData,
                    status: 200
                };
            } else {
                customerSummary = await customerSummaryClient(custNum);
            }
            if(customerSummary?.status === 401){
                localStorage.clear();
                navigate("/login", { replace: true });
            }

            if(customerSummary?.data === null || customerSummary?.data === undefined){
                setCsError("Unable to load service addresses, please try again later.");
            }
            if(type === "byAddress")
                setCustomerSummaryData(customerSummary?.data);
            else if(type === "byCustNum")
                setAddressByCust(customerSummary?.data?.ServiceAddresses || []);
        } catch(err){
            setCsError("Unable to load service addresses, please try again later.");
        } finally {
            setIsOverLayLoading(false);
        }
    }

    const handleAccountClick = () => {
        if(!addressInfo.selectedAddr || !addressInfo.custNo){
            setError("Please enter the required information to look up your account.");
            return false;
        }
        navigate("/my-account/account-summary", { state: addressInfo});
    }

    const handleAccountAddr = (selected) => {
        if(!selected || selected.length === 0){
            setError("Please enter the required information to look up your account. ");
            setAddressInfo({selectedAddr: '', custNo: ''});
            return false;
        } else {
            setError("");
        }

        const value = selected[0]?.id || selected[0];
        const addrParts = value.split(" | ");
        const address = addrParts?.[0];
        const custNo = addrParts?.[1];
        const addrID = addrParts?.[2];
        
        setAddressInfo({selectedAddr: address, custNo: custNo});
        dispatch(setSelectedServiceAddress(address + " | " + custNo + " | " + addrID));
    }

    const makeSalesAgreementObj = (salesAgreements) => {
        let value = [];
        let data = {};
        salesAgreements.forEach((sa) => {
            if(!value.includes(sa.invoiceNumber+"_"+sa.salesAgrNum)){
                value.push(sa.invoiceNumber+"_"+sa.salesAgrNum);
                data = {...data, [sa.invoiceNumber+"_"+sa.salesAgrNum]: sa };
            }
        });

        return { value, data };
    }
    
    const handleCustAddr = async (custNum, address, addrID) => {

        if (currentController) {
            currentController.abort();
        }
        setAllInvoices([]);
        setSelectedInvoices({});
        setTotalAmount(0);
        setIsLoading(true);
        setInvoiceError("");
        setIsIB(false);
        setCsError("");
        setSelectedZIP(null);

        let controller = new AbortController();
        setCurrentController(controller);
        const signal = controller.signal;
        dispatch(setSelectedCustomer(custNum));
        try{
            const response = await AccountDetailsClient(custNum, address.split(", ")[0], signal, addrID);

            if (response?.CODE === "ER" && response?.DESCRIPTION === "NO ACTIVE CUSTOMER INFORMATION") {
                setInvoiceError(response?.DESCRIPTION);
                setIsLoading(false);
                return;
            }
            
            
            if (response && (response?.errorStatus === 500 || response?.errorStatus === 424)){
                throw new Error(response?.errorMessage || "Unable to load invoices, please try again later.");
            } else if (response?.errorStatus === 401) {
                localStorage.clear();
                navigate("/login");
            } else if (response?.errorStatus === 424) {
                setInvoiceError("Some error occured.");
            }

            setCurrentController(null);

            setSelectedZIP(address.split(" ").pop());
            const accountDetails = getDataFromLocalStorage(response);
            let activeInvoices = [];
            
            let index= 0;
            accountDetails?.serviceAgreements.forEach((invoice) => {
                // if sales agreement has bad debt, do not show invoice
                if (invoice.isBadSalesAgreement !== 'N' && invoiceAmountDue(invoice) > 0 && (invoice.inactiveReason !== 'SSP' && invoice.inactiveReason !== 'NRN')) return null;

                if(invoice?.Invoices.length === 0) return null;
                
                activeInvoices[index] = invoice;
                
                let Invoices = [];
                
                invoice?.Invoices.forEach(inv => {
                    if (inv.invoiceBalance > 0 && inv.invoiceOpen === "Y") {
                        Invoices.push(inv);
                    }
                });
                activeInvoices[index].Invoices = Invoices;
                index++;
            });

            setAllSA(activeInvoices);

            let activeServiceAgreements = [];
            Object.values(activeInvoices).forEach(invoiceArr => {
                if(invoiceArr?.Invoices.length > 0){

                invoiceArr?.Invoices.length > 0 && invoiceArr?.Invoices.forEach(inv => {
                    if (inv.invoiceBalance > 0 && inv.invoiceOpen === "Y") {
                        activeServiceAgreements.push({
                            payTotalPymt: inv.invoiceBalance,
                            salesAgrNum: inv?.salesAgrNum,
                            invoiceNo: inv?.invoiceNum,
                            invoiceAmt: inv?.invoiceBalance,
                            payBunit: invoiceArr?.asgBunit,
                            svcLineDesc: inv?.svcDescription,
                            dueDate: inv?.invoiceDate,
                            totalbySA: { [inv.salesAgrNum]: inv.invoiceBalance }
                        });
                    }
                })
                }
            });

            let consolidatedInvoices = [];
            const invoiceKeys = new Set();
            activeServiceAgreements.forEach(agreement => {
                const invoiceKey = `${agreement.invoiceNo}|${agreement.svcLineDesc}|${agreement.invoiceAmt}`;

                if (invoiceKeys.has(invoiceKey)) return;
                invoiceKeys.add(invoiceKey);

                const existing = consolidatedInvoices.find(item => item?.invoiceNo === agreement?.invoiceNo);
                if (existing) {
                    existing.payTotalPymt += agreement.invoiceAmt;
                    existing.svcLineDesc += `$ ${agreement.svcLineDesc}`;
                    existing.invoiceAmt += `, ${agreement.invoiceAmt}`;
                    existing.salesAgrNum += `, ${agreement.salesAgrNum}`;
                    existing.totalbySA = { ...existing.totalbySA, [agreement.salesAgrNum]: (existing.totalbySA[agreement.salesAgrNum] || 0) + agreement.invoiceAmt };
                } else {
                    consolidatedInvoices.push({ ...agreement });
                }
            });
            setAllInvoices(consolidatedInvoices);
            
        } catch(err){
            if (error.name === 'AbortError') {
                console.log('Fetch request was cancelled by user action.');
            } else {
                setInvoiceError("Unable to load invoices, please try again later.");
            }
        } finally {
            setIsLoading(false);
        }
    }

    const handleClose = () => setIsModalOpen(false);

    const getIframeUrl = async(paymentType) => {
        setIsLoading(true);
        setIframeLoading(true);
        try{    
            const response = await GetAccessToken(paymentType, selectedCustomerNumber[0] || "");            
            const accessToken = decryptData(response?.data?.AccessToken, "step1");
            const iFrameUrl = response.data.Signature;            
            if(paymentType === 'card'){
                setCookie('IUcard', iFrameUrl, 20);
            } else {
                setCookie('IUbank', iFrameUrl, 20);
            }
            setIframeURLToken({IFrameUrl: iFrameUrl, AccessToken: accessToken});
        } catch(err){
        } finally {
            setIsLoading(false);
            setIframeLoading(false);
        }
    }
    

    const handlePayInvoices = async (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        if (e && typeof e.stopPropagation === "function")
            e.stopPropagation();

        const isMissionAvailable = await missionStatusCheck();
        if (!isMissionAvailable) {
            setMissionDown(true);
            return;
        }

        if(totalAmount === 0){
            setInvoiceError("Choose one or more invoices to review your total and continue with payment.");
            return false;
        } else {
            setInvoiceError("");
            setIsModalOpen(true);
        }
    }

    const checkPaymentStatus = async () => {
        
        const defaultInvoices = allInvoices.map(inv => ({ invoiceNumber: inv.invoiceNo, saNumber: inv.salesAgrNum }));
        console.log('Default invoices:', defaultInvoices);
        // dedupe by value since Set doesn't dedupe object references
        const allPaidInvoices = Array.from(
            new Map([...defaultInvoices, ...paidInvoices].map(inv => [`${inv.invoiceNumber}_${inv.saNumber}`, inv])).values()
        );
        
        // dont check for invoices status if no invoice is submitted for payment
        if(allPaidInvoices.length === 0)
            return;

        try {
            const response = await paymentStatusClient(allPaidInvoices);
                
            if (response?.error) {
            } else if (response?.data) {
                // Process the payment status response
                const processing = [];
                const failed = [];
                const success = [];
                const successPaidInvoices = [];
                const not_found = [];
                const onqueue = [];
                const pending = [];
             
                response?.data.forEach(item => {
                    const invoiceNumber = item.invoice_number;
                    const salesAgrNum = item.sa_number;
                    const status = item.status.toLowerCase();

                    if (status === 'processing' || status === 'in-progress') {
                        processing.push(invoiceNumber);
                    } else if (status === 'failed') {
                        failed.push(invoiceNumber);
                    } else if (status === 'success') {
                        success.push(invoiceNumber);
                        successPaidInvoices.push({ invoiceNumber, saNumber: salesAgrNum });
                    }else if (status === 'not_found') {
                        not_found.push(invoiceNumber);
                    }else if (status === 'onqueue') {
                        onqueue.push(invoiceNumber);
                    }else if (status === 'pending') {
                        pending.push(invoiceNumber);
                    }
                });

                setInvoiceStatuses({ processing, failed, success, not_found, onqueue, pending });
                
                // Add successful invoices to paidInvoices
                if (successPaidInvoices.length > 0) {
                    setPaidInvoices(prev => {
                        // dedupe by value since Set doesn't dedupe object references
                        return Array.from(
                            new Map([...prev, ...successPaidInvoices].map(inv => [`${inv.invoiceNumber}_${inv.saNumber}`, inv])).values()
                        );
                    });
                }
            } else {            }
        } catch (err) {
            console.error('Error checking payment status:', err);
        } finally {}
    };

    const checkPaymentStatusRef = useRef(checkPaymentStatus);
    checkPaymentStatusRef.current = checkPaymentStatus;

    useEffect(()=>{         
        const intervalMs = Globals && Globals["invoice-status-call-time"] ? parseInt(Globals["invoice-status-call-time"]) : process.env.REACT_APP_INVOICE_STATUS_CALL_TIMEOUT; // default 2 minutes 
        const intervalId = setInterval(() => {
            checkPaymentStatusRef.current();
        }, intervalMs * 60 * 1000); //in milliseconds

        // scroll to top on component load
        window.scrollTo(0, 0);

        // Cleanup interval on component unmount
        return () => {
            clearInterval(intervalId);
            if (currentController) {
                currentController.abort();
            }
        }
    },[]);

    useEffect(() => {
        (async () => {
            if(allInvoices.length > 0)
                await checkPaymentStatus();
        })();
    }, [allInvoices]);

    let allServiceAddresses = [];
    let allAddressesSet = localStorage.getItem("serviceAddressesWithCustomerNumbers") ? JSON.parse(localStorage.getItem("serviceAddressesWithCustomerNumbers")) : null;

    allServiceAddresses = allCusAddresses || [];

    
    const [paymentData, setPaymentData] = useState(null);

     useEffect(() => {
        if (selectedCustomerNumber[0]){
            const fetchPaymentData = async () => {
                try {
                    const paymentInfo = await ViewPaymentMethodsClient({
                    cusNum: selectedCustomerNumber[0],
                    });
                    const methods = paymentInfo?.data?.PaymentMethods || [];
                    
                    setPaymentData(methods);
                } catch (error) {
                    console.error("Error fetching payment methods:", error);
                }
            };
            if(isModalOpen)
                fetchPaymentData();
            else
                setPaymentData(null);
        }
    }, [selectedCustomerNumber, paidInvoices, isModalOpen]);

    // get all customer summmary data for all customers for a user
      useEffect(() => {
        const getAllCustomers = async() => {
          try{
            let allcustomerSummary;
            if(customerInfo && customerInfo.length > 0 && isLoggedIn){
                let custData = { Customers: customerInfo};
                if(custData){
                    allcustomerSummary = {
                        data: custData,
                        status: 200
                    };
                }
            } else {
                allcustomerSummary = await allCustomerSummaryClient();
            }
            if (allcustomerSummary?.status && allcustomerSummary?.status === 401 ) {
              console.log("Unauthorized access - 401");
              localStorage.clear();
              navigate("/login", { replace: true, state: { from: location } });
              return;
            }
            
                        if (allcustomerSummary?.data === null || allcustomerSummary?.data === undefined ) {
                            return;
                        }
    
                        let allAddr = [];
    
                        if(allcustomerSummary.status === 200 && allcustomerSummary?.data?.Customers){
                            allcustomerSummary?.data?.Customers.forEach((cus) => {
                                let customer = cus?.CustomerNumber || "";
                                cus.ServiceAddresses.forEach((addr) => {
                                        let serviceAddress = addr?.address || "";
                                        let addrID = addr?.addressId || "";
                                        allAddr.push({
                                                id: serviceAddress + " | " + customer + " | " + addrID,
                                                name: serviceAddress + " | " + customer
                                        });
                                });
                            });
                        }
    
            setAllCusAddresses(allAddr);
            setCustomerSummaryData(allcustomerSummary?.data?.Customers?.[0]);
            if(!customerInfo)
                dispatch(setCustomerInfo(allcustomerSummary?.data?.Customers));

                    } catch(err){          }
                }

                const initializeCustomers = async () => {
                    const isMissionAvailable = await missionStatusCheck();

                    if (isMissionAvailable) {
                            getAllCustomers();
                    } else {
                            setMissionDown(true);
                    }
                };

                initializeCustomers();
        }, []);

  return (
    <section>
        {missionDown && <MissionStatusChecker />}
      {isOverLayLoading && <OverLayLoader isOpen={isOverLayLoading} />}
      <div className={invoiceCSS["after-login"]}>
        <div className="container">
            <div className="row">
                <div className={`col-md-8 m-auto ${invoiceCSS["select-flex"]}`}>
                    <Typeahead 
                        
                        id="select_loc_or_addr"
                        onChange={(selected) => {
                            setSelectedServiceAddr(selected);
                            handleAccountAddr(selected);
                        }}
                        options={allServiceAddresses && allServiceAddresses.length > 0 ? allServiceAddresses : [{"name": "Loading...", disabled: true}]}
                        labelKey={"name"}
                        placeholder="Search by location or service address"
                        selected={selectedServiceAddr}
                        filterBy={(option, props) => {
                            if (props.selected.length > 0) {
                                return true; // Show all options if something is selected
                            }
                            // Standard filtering when no selection exists
                            if(option?.name){
                                return option.name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
                            }
                            else {
                                return option.toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
                            }
                        }}
                    >
                        {({ onClear, selected }) => (
                            <div className="rbt-aux">
                                {/* Render clear button if there are selections */}
                                {!!selected.length
                                 ? <ClearButton onClick={onClear} />
                                 : <img src='/images/header/Cheveron-1.png' style={{marginRight: "20px"}} alt='closeIcon' />
                                }
                            </div>
                        )}
                    </Typeahead>
                    <button className={`btn ${invoiceCSS["btn-primary"]} ${invoiceCSS["btn-search"]}`} onClick={handleAccountClick} >Go to account</button>
                </div>
                {error && <div className={`col-md-8 m-auto mb-3  ${invoiceCSS["red-txt"]}`}>{error}</div>}
            </div>

            <div className={invoiceCSS["horizontal-line"]}>
                <p className="text-center mx-auto">OR</p>
            </div>


            <div className={`row ${invoiceCSS["mt-40"]}`}>
                {/* Search By Customer Number */}
                <div className={`col-md-4 ${invoiceCSS["customer-list"]}`}>
                    
                    <Typeahead
                        clearButton={true}
                        id="customerNumberSelect"
                        labelKey={"name"}
                        onChange={(selected) => {
                            setSelectedCustomerNumber(selected);
                            setAddressByCust([]);
                            setAllInvoices([]);
                            setIsLoading(false);
                            if (selected && selected.length > 0) {
                                getCustomerSummary(selected[0], "byCustNum");
                            }
                        }}
                        options={missionDown ? [{"name": "Loading...", disabled: true}] : (custNumbers || [])}
                        placeholder="Search by customer number"
                        selected={selectedCustomerNumber}
                        filterBy={(option, props) => {
                            if (props.selected.length > 0) {
                                return true; // Show all options if something is selected
                            }
                            // Standard filtering when no selection exists
                            if(option?.name){
                                return option.name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
                            }
                            else {
                                return option.toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
                            }
                        }}
                    >
                        {({ onClear, selected }) => (
                            <div className="rbt-aux">
                                {/* Render clear button if there are selections */}
                                {!!selected.length
                                 ? <ClearButton onClick={onClear} className={`rbt-close`} />
                                 : <img src='/images/header/Cheveron-1.png' style={{marginRight: "20px"}} alt='closeIcon' />
                                }
                            </div>
                        )}
                    </Typeahead>

                    {/* Service Addresses */}
                    {selectedCustomerNumber && selectedCustomerNumber.length > 0 && <div className={"service-address"}>
                        <div className={`${invoiceCSS["form-check"]} ${addressByCust && addressByCust.length > 30 ? invoiceCSS["limitAddress"] : ""}`}>
                            {addressByCust && addressByCust.length > 0 && addressByCust.map((addressDetails, index) => {
                                const address = `${addressDetails.address}, ${addressDetails.city}, ${addressDetails.state} ${addressDetails.postalCode}`;
                                return <div key={selectedCustomerNumber[0] + "_" + addressDetails.addressId} className={`${invoiceCSS["address-radio"]}`}>
                                    <input type="radio" className={invoiceCSS["form-check-input"]} id={address+ "_" + addressDetails.addressId} name="addressByCust" value={"addressByCust"+index} onClick={() => handleCustAddr(selectedCustomerNumber[0] || "", address, addressDetails.addressId)} />
                                    <label className={invoiceCSS["form-check-label"]} htmlFor={address+ "_" + addressDetails.addressId}>{address}</label>
                                </div>
                            })}
                        </div>
                    </div>}
                </div>

                <hr className={`d-md-none my-4 ${invoiceCSS["hr-p"]}`} />

                <div className={`col-md-8 ${invoiceCSS["invoices"]}`} >
                {   !selectedCustomerNumber || selectedCustomerNumber.length === 0
                 ?  (
                    <div className={invoiceCSS["open-invoice-text"]}>
                        <h3>No account selected.</h3>
                        <p>Please select a customer number and service address to view any pending invoices.</p>
                    </div>
                    )
                :   (
                    selectedCustomerNumber && selectedCustomerNumber.length > 0 && isOverLayLoading
                        ? (
                            <div className={invoiceCSS["open-invoice-text"]}>
                                <p>Please wait! Loading the Service Addresses...</p>
                            </div>
                          )
                        : (
                            selectedCustomerNumber && selectedCustomerNumber.length > 0 && !isOverLayLoading && allInvoices.length === 0 && !isLoading
                                ? (
                                    csError !== ""
                                        ? <div className={invoiceCSS["open-invoice-text"]}>
                                            <p>{csError}</p>
                                          </div>
                                        : (
                                            invoiceError === ""
                                            ? (
                                                $('input[name="addressByCust"]').is(':checked') === false
                                                ? <div className={invoiceCSS["open-invoice-text"]}>
                                                    <h3>No address selected.</h3>
                                                    <p>Please select a service address to view any pending invoices.</p>
                                                  </div>
                                                : <div className={invoiceCSS["open-invoice-text"]}>
                                                    <h2>No Invoices Found</h2>
                                                    <p>Currently we cannot find any pending invoices for this service address.</p>
                                                  </div>
                                              )
                                            : <div className={invoiceCSS["open-invoice-text"]}>
                                                <h3>Error in loading invoices.</h3>
                                                <p>{invoiceError}</p>
                                              </div>
                                          )
                                  )
                                : (
                                    isLoading
                                        ? <Loader />
                                        : (
                                            invoiceError !== "" && parseInt(totalAmount) === 0 && allInvoices.length === 0
                                                ? <div className={invoiceCSS["open-invoice-text"]}>
                                                    <h3>Error in loading invoices</h3>
                                                    <p>{invoiceError}</p>
                                                  </div>
                                                : (
                                                    allInvoices.length !== 0 && selectedCustomerNumber && selectedCustomerNumber.length > 0 && !isOverLayLoading && !isIB 
                                                        ? ( <>
                                                            {invoiceError !== "" && parseInt(totalAmount) === 0 &&
                                                                <div className={invoiceCSS["open-invoice-text"]}>
                                                                    <h3>No invoices selected</h3>
                                                                    <p>{invoiceError}</p>
                                                                </div>
                                                            }

                                                            <div className={invoiceCSS["open-invoice"]}>
                                                                {/* Invoices List */}
                                                                    <div>
                                                                        <h3>Open Invoices</h3>
                                                                        <p style={{marginTop: "-5px"}}>May not include all pending invoices.</p>
                                                                    </div>

                                                                    <div className={`${invoiceCSS["invoice-container"]}`}>
                                                                        {/*  Open Invoces  */}

                                                                        {pageData && pageData.length > 0 && pageData.filter(invoice => !invoiceStatuses.success.includes(invoice.salesAgrNum)).map((invoice) => {

                                                                            let amount = invoice?.payTotalPymt > 0 ? invoice?.payTotalPymt : 0;
                                                                            const {dollars,cents} = amountFormatter(amount);
                                                                            const isProcessing = invoiceStatuses.processing.includes(invoice.invoiceNo);
                                                                            const isFailed = invoiceStatuses.failed.includes(invoice.invoiceNo);
                                                                            const isNotFound = invoiceStatuses.not_found.includes(invoice.invoiceNo);
                                                                            const isOnQueue = invoiceStatuses.onqueue.includes(invoice.invoiceNo);
                                                                            const isPending = invoiceStatuses.pending.includes(invoice.invoiceNo);
                                                                            const isSuccess = invoiceStatuses.success.includes(invoice.invoiceNo);
                                                                            const isInvoiceSubmittedForPayment = paidInvoices.includes(invoice.invoiceNo) && !isProcessing && !isOnQueue && !isPending && !isSuccess;

                                                                            let svcLines = invoice.svcLineDesc.split("$ ") || [];
                                                                            let invAmounts = String(invoice.invoiceAmt).split(", ") || [];
                                                                            let seeMore = false;

                                                                            let firstPartInv = [];
                                                                            let firstPartAmt = [];
                                                                            let secondPartInv = [];
                                                                            let secondPartAmt = [];

                                                                            if(svcLines.length > 2) {
                                                                                seeMore = true;
                                                                                
                                                                                firstPartInv = svcLines.splice(0, 2);
                                                                                secondPartInv = svcLines;

                                                                                firstPartAmt = invAmounts.splice(0, 2);
                                                                                secondPartAmt = invAmounts;
                                                                            }
                                                                            else {
                                                                                seeMore = false;
                                                                                firstPartInv = svcLines;
                                                                                firstPartAmt = invAmounts;
                                                                            }

                                                                            return <div key={invoice.invoiceNo} className={`${invoiceCSS["invoice-box"]}`}>
                                                                            <div className={invoiceCSS["invoice-box-content"]}>
                                                                                <div className={`${invoiceCSS["form-check-label"]} ${invoiceCSS["invoice-box-left"]} d-flex gap-2 align-items-center ${isProcessing || isOnQueue || isPending || isSuccess || (isInvoiceSubmittedForPayment && !isFailed) ? 'opacity-50 pe-none' : ''}`}>
                                                                                    <label htmlFor={`due-pay-${invoice.invoiceNo}`} className='m-0'>
                                                                                        <input type="checkbox" id={`due-pay-${invoice.invoiceNo}`} name={`${invoice.svcLineDesc}`} style={{backgroundColor: '#fff'}} className={invoiceCSS["checkmark"]} onChange={handleInvoiceSelection} disabled={ isProcessing || isOnQueue || isPending || isSuccess || (isInvoiceSubmittedForPayment && !isFailed)} checked={selectedInvoices?.[invoice.invoiceNo]?.length > 0}/>
                                                                                    </label>
                                                                                    Invoice number: <span>{invoice.invoiceNo}</span>
                                                                                </div>
                                                                                
                                                                                <div className={`${invoiceCSS["due-amount"]} ${isProcessing || isOnQueue || isPending || isSuccess || (isInvoiceSubmittedForPayment && !isFailed) ? 'opacity-50 pe-none' : ''} mb-2`} style={{marginLeft: '28px'}}>Total Due: <span>{Globals.currencySymbol}{dollars}.{cents}</span></div>
                                                                                
                                                                                <div className={`${invoiceCSS["due-date"]} mb-2`}>
                                                                                    <div className={`${invoiceCSS["invoice-no"]} ${isProcessing || isOnQueue || isPending || isSuccess || (isInvoiceSubmittedForPayment && !isFailed) ? 'opacity-50 pe-none' : ''}`} style={{marginLeft: '28px'}}>
                                                                                    {firstPartInv.length > 0 && firstPartInv.map((line, index) => {
                                                                                        const {dollars, cents} = amountFormatter(parseFloat(firstPartAmt[index]));
                                                                                        return <p className={`${invoiceCSS["due-amount"]} mb-0`} key={index}>
                                                                                            {line}:&nbsp;
                                                                                            <span>
                                                                                                {Globals.currencySymbol}{dollars}.{cents}
                                                                                            </span>
                                                                                        </p>
                                                                                    })}
                                                                                    </div>
                                                                                    <div className={invoiceCSS["success"]} style={{alignSelf: 'end', textAlign:'end', marginTop: '10px'}}>
                                                                                        <span style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 'normal'}} data-bs-toggle="modal" data-bs-target={`#invoice-${invoice.invoiceNo}`}>{seeMore && `See more`}</span>
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <div className={`${invoiceCSS["due-date"]} mb-0`}>
                                                                                    <div>&nbsp;</div>
                                                                                    <div className={`${isFailed ? invoiceCSS["failed"] : isSuccess ? invoiceCSS["success"] : invoiceCSS["pending"]}`}>
                                                                                        {(isProcessing || (isInvoiceSubmittedForPayment && !isFailed)) && `Processing...`}
                                                                                        {isFailed && `Failed`}
                                                                                        {isSuccess && `Success`}
                                                                                        {isOnQueue && `In-Queue`}
                                                                                        {isPending && `Pending`}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {seeMore && <div className={`modal fade`} id={`invoice-${invoice.invoiceNo}`} data-bs-backdrop='static' role='dialog' tabIndex='-1' aria-hidden='true'>
                                                                                <div className={`modal-dialog modal-dialog-centered`} role='document' >
                                                                                <div className={`modal-content`}>
                                                                                    
                                                                                    <div className="modal-header border-0">
                                                                                        <div className='modal-title'>
                                                                                            <h5 className="modal-title">Invoice Details</h5>
                                                                                        </div>
                                                                                        <button className="btn-close leadform-close-btn" aria-label="Close" type="button" data-bs-dismiss="modal"></button>
                                                                                    </div>
                                                                                    
                                                                                    <div className='modal-body p-0'>  
                                                                                        <div className="container">
                                                                                            <div className="row">
                                                                                                <div className="col-12">
                                                                                                    <div style={{ paddingBottom: '30px' }}>
                                                                                                    {secondPartInv.length > 0 && secondPartInv.map((line, index) => {
                                                                                                        const {dollars, cents} = amountFormatter(parseFloat(secondPartAmt[index]));
                                                                                                        return <p className={`${invoiceCSS["due-amount"]} mb-0`} key={index}>
                                                                                                            {line}:&nbsp;
                                                                                                            <span>
                                                                                                                {Globals.currencySymbol}{dollars}.{cents}
                                                                                                            </span>
                                                                                                        </p>
                                                                                                    })}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    
                                                                                </div>
                                                                                </div>
                                                                            </div>}{/* Modal Ends */}
                                                                            </div>
                                                                        })}
                                                                    </div>

                                                                    {showPagination && <div className={`pagination-container`}>
                                                                        <Pagination
                                                                            currentPage={page}
                                                                            totalItems={totalItems}
                                                                            pageSize={pageSize}
                                                                            onPageChange={setPage}
                                                                            maxButtons={7}
                                                                        />
                                                                    </div>}

                                                                    <hr />
                                                                    <div className={invoiceCSS["total-due"]}>
                                                                        <p className={invoiceCSS["total-txt"]}>Total Due</p>
                                                                        <p className={invoiceCSS["total-txt"]}>${totalAmount}</p>
                                                                    </div>

                                                                    <button type='button' className={`btn ${invoiceCSS["btn-primary"]} ${invoiceCSS["btn-search"]}`} onClick={handlePayInvoices} disabled={Object.values(selectedInvoices).filter(inv => inv.length > 0).length === 0}>Pay Now </button>
                                                            </div>
                                                            </>
                                                        )
                                                        : (
                                                            isIB
                                                             ? <div className={invoiceCSS["open-invoice-text"]}>
                                                                    <p>{invoiceError}</p>
                                                                </div>
                                                             :  allInvoices.length === 0 && selectedCustomerNumber && selectedCustomerNumber.length > 0 && !isOverLayLoading && <div className={invoiceCSS["open-invoice-text"]}>
                                                                <h2>No Invoices Found</h2>
                                                                <p>Currently we cannot find any pending invoices for this service address.</p>
                                                            </div>
                                                        )
                                                )
                                        )
                                  )
                          )
                    )
                }
                </div>
            </div>
        </div>
      </div>
 
      {isModalOpen && <PaymetricModal 
        isModalOpen={isModalOpen}
        paymentType={paymentType} 
        setPaymentType={setPaymentType}
        invoicePayAPIPayload={invoicePayAPIPayload}
        setInvoicePayAPIPayload={setInvoicePayAPIPayload}
        selectedZIP={selectedZIP}
        iframeURLToken={iframeURLToken}
        totalAmount={totalAmount}
        getIframeUrl={getIframeUrl}
        iframeLoading={iframeLoading}
        setIframeLoading={setIframeLoading}
        setInvoiceStatuses={setInvoiceStatuses}
        setIframeURLToken={setIframeURLToken}

        onPaymentSuccess={async(paidInvoiceIds) => {
          setPaidInvoices(paidInvoiceIds);
          setSelectedInvoices({});
          setTotalAmount(0);
          await checkPaymentStatus();
        
          // Uncheck all checkboxes
          $('input[type="checkbox"][id^="due-pay-"]').prop('checked', false);
        }}
          paymentDataProp={paymentData}
          handleClose={handleClose}
      />}
    </section>
  )
}

export default Invoices;